import Axios from "axios";
import {
    SET_PROJECT_THEME_LIST,
    UNSET_PROJECT_THEME_LIST,
  } from "@/store/mutation-types";
import { saveUpdateProjectTheme, getProjectThemeList } from "@/store/api";
// initial state
const state = {
  getProjectThemeList: [],
};

const getters = {
  getProjectThemeList(state) {
    return state.getProjectThemeList;
  },
};

const mutations = {
  [SET_PROJECT_THEME_LIST](state, data) {
    state.getProjectThemeList = data;
  },
  [UNSET_PROJECT_THEME_LIST](state) {
    state.getProjectThemeList = [];
  },

};

const actions = {

  saveUpdateProjectTheme({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateProjectTheme, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {

          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  getProjectThemeList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(getProjectThemeList, data)
        .then(function (response) {
          commit('SET_PROJECT_THEME_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_PROJECT_THEME_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};